import Footer from "components/Footer/Footer";
import TopNavigation from "components/Navigation/TopNavigation";
import TestDaily from "pages/Experiment/DailyCard.js";
import LinkAdminPage from "pages/Experiment/LinkAdminPage";
import LinkPage from "pages/Experiment/LinkPage";
import PlansPage from "pages/Experiment/Plans";
import TestPage from "pages/Experiment/TestPage";
import TestDetail from "pages/Experiment/TestPageDetail";
import {
  default as PaymentThanksScreen,
  default as SuccessPage,
} from "pages/Experiment/TestPaymentsThanks";
import { FailPage } from "payments/Fail";
import AlphaHome from "pages/Home/AlphaHome";
import Home from "pages/Home/Home";
import AlphaHotStock from "pages/HotStock/AlphaHotStock";
import HotStock from "pages/HotStock/HotStock";
import NotFound from "pages/NotFound/NotFound";
import AlphaNote from "pages/TraderDetail/AlphaNote";
import TraderDetail, { CuidProvider } from "pages/TraderDetail/TraderDetail";
import AlphaTraderList from "pages/TraderList/AlphaTraderList";
import { QueryClient, QueryClientProvider } from "react-query";
import { Route, Routes } from "react-router-dom";
import styled, { createGlobalStyle } from "styled-components";
import "./App.css";
import "./assets/fonts/pretendard-subset.css";
import FreeBoardPage from "pages/Experiment/FreeBoard";
import MyInfoPage from "pages/Experiment/MyInfoPage";
import LandingTradingJournal from "pages/Home/LandingTradingJournal";
import PromotionModal from "components/Modals/PromotionModal";
import { useState, useEffect } from "react";

const GlobalStyle = createGlobalStyle`
  body {
    font-family: Pretendard;
  }
`;

const queryClient = new QueryClient();

const MainWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  background: #ffffff;
  // min-width: 1128px;

  @media (max-width: 1240px) {
    width: 100%;
  }
`;

const modalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "80%",
    maxWidth: "600px",
    padding: "0",
    border: "none",
    borderRadius: "12px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    overflow: "hidden",
  },
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.75)",
  },
};

function App() {
  const [isPromotionModalOpen, setIsPromotionModalOpen] = useState(false);

  useEffect(() => {
    // localStorage에서 "1주일 동안 안보기" 설정 확인
    const dontShowUntil = localStorage.getItem("promotion_dont_show_until");
    const now = new Date().getTime();

    if (dontShowUntil) {
      // 저장된 날짜가 현재보다 미래이면 모달을 표시하지 않음
      if (parseInt(dontShowUntil, 10) > now) {
        return;
      }
    }

    // 조건을 만족하면 모달 표시
    setIsPromotionModalOpen(true);
  }, []);

  const handleClosePromotionModal = () => {
    setIsPromotionModalOpen(false);
  };

  const handleDontShowForWeek = () => {
    // 1주일 후 날짜 계산 (7일 * 24시간 * 60분 * 60초 * 1000밀리초)
    const oneWeekLater = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
    localStorage.setItem("promotion_dont_show_until", oneWeekLater.toString());
    setIsPromotionModalOpen(false);
  };

  // const navigate = useNavigate();
  // const location = useLocation();
  // const [isModalOpen, setIsModalOpen] = useState(false);

  // useEffect(() => {
  //   const visitCount = parseInt(
  //     localStorage.getItem("alphanote_visitCount") || "0",
  //     10
  //   );
  //   const isLoggedIn = !!localStorage.getItem("access_token");

  //   if (!isLoggedIn && location.pathname !== "/login") {
  //     if (visitCount >= 20) {
  //       setIsModalOpen(true);
  //     } else {
  //       localStorage.setItem("alphanote_visitCount", visitCount + 1);
  //     }
  //   }
  // }, [navigate, location]);

  // const closeModal = () => {
  //   setIsModalOpen(false);
  //   navigate("/login");
  // };

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">
        <TopNavigation />
        <main>
          {/* {!isModalOpen && ( */}
          <CuidProvider>
            <MainWrapper>
              <Routes>
                {/* <Route path="/" element={<AlphaHome />} /> */}
                <Route path="/" element={<LandingTradingJournal />} />
                <Route path="/trader" element={<AlphaTraderList />} />
                <Route path="/trader/:cuid" element={<TraderDetail />} />
                <Route path="/hotstock/*" element={<AlphaHotStock />} />
                <Route path="/mynote" element={<TraderDetail />} />
                <Route path="/note" element={<AlphaNote />} />
                <Route path="/competition" element={<Home />} />
                <Route path="/exp/test" element={<TestPage />} />
                <Route path="/exp/detail/:cuid" element={<TestDetail />} />
                <Route path="/exp/daily" element={<TestDaily />} />
                <Route path="/exp/hotstock/*" element={<HotStock />} />
                <Route path="/exp/thx/*" element={<PaymentThanksScreen />} />
                <Route path="/confirm" element={<SuccessPage />} />
                <Route path="/success" element={<PaymentThanksScreen />} />
                <Route path="/fail" element={<FailPage />} />
                <Route path="/plans/*" element={<PlansPage />} />
                {/* <Route path="/exp/chart/*" element={<TradeTimeScatter />} /> */}
                <Route path="/link/:link" element={<LinkPage />} />
                <Route path="/link" element={<LinkAdminPage />} />
                <Route path="*" element={<NotFound />} />
                <Route path="/info" element={<MyInfoPage />} />
                <Route path="/freeboard" element={<FreeBoardPage />} />
              </Routes>
            </MainWrapper>
          </CuidProvider>
          {/* )} */}
        </main>
        <Footer />
        <PromotionModal
          isOpen={isPromotionModalOpen}
          onClose={handleClosePromotionModal}
          onDontShowForWeek={handleDontShowForWeek}
        />
        {/* {!isModalOpen && <Footer />}
        <ReactModal
          isOpen={isModalOpen}
          // onRequestClose={closeModal}
          contentLabel="Login Required"
          style={modalStyles}
        >
          <LoginRequired closeModal={closeModal} />
        </ReactModal> */}
      </div>
    </QueryClientProvider>
  );
}

export default App;
